export const agenda = {
  agendaDuration: 'duração',
  agendaCurtainCopy: 'Copiar link',
  agendaCurtainFlag: 'Sinalizar conteúdo',
  agendaCurtainFlagSent: 'Conteúdo sinalizado',
  agendaLinkCopied: 'Link copiado!',
  agendaStartsAt: 'Começa às ',
  agendaEndsAt: 'Termina às ',
  agendaSpeakers: 'Palestrantes',
  agendaSeeAllSpeakers: 'Ver tudo',
  agendaAddToSchedule: 'Adicionar ao meu cronograma',
  agendaRemoveFromSchedule: 'Remover do meu cronograma',
  agendaAddedToSchedule: 'Adicionado ao meu cronograma!',
  agendaRemovedFromSchedule: 'Removido do meu cronograma!',
  agendaCalendar: 'Calendário',
  agendaAddToCalendar: 'Adicionar ao calendário do sistema?',
  agendaCalendarSkip: 'Pular',
  agendaCalendarAdd: 'Adicionar',
  agendaNow: 'AGORA',
  agendaModerators: 'Moderadores'
}
